import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Link } from 'react-router-dom';
import { usePublicContent } from '../../context/PublicContent';

export const EditorialBody = ({body}) => {
  const {cities, articles} = usePublicContent();
  const published = new Set([...cities.map(c => `/locations/${c.slug}`), ...articles.map(a => `/blog/${a.slug}`)]);
  const components = {
    h1: ({children}) => <h2>{children}</h2>,
    a: ({href, children, node}) => {
      const suffix = node.position?.start?.offset ?? 'link';
      if (!href) return <span>{children}</span>;
      if (/^\/(blog|locations)\//.test(href) && !published.has(href.split('#')[0])) return <span>{children}</span>;
      if (href.startsWith('/') && !href.startsWith('//')) return <Link to={href} data-testid={`content-link-${href.replace(/[^a-z0-9]/gi, '-')}-${suffix}`}>{children}</Link>;
      return <a href={href} target={href.startsWith('https:') ? '_blank' : undefined} rel="noopener noreferrer" data-testid={`content-external-${suffix}`}>{children}</a>;
    },
    img: () => null,
  };
  return <div className="editorial-body" data-testid="editorial-body"><ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml components={components}>{body}</ReactMarkdown></div>;
};